<template>
  <oido-button v-bind="$attrs" icon="download" @click="download" :showSpinner="downloading"></oido-button>
</template>


<script setup>
import OidoButton from './OidoButton.vue';
</script>
<script>

import axios from "axios";


export default {
  props: ['url', 'filename'],
  data() {
    return {
      downloading: false
    }
  },
  methods: {
    async download() {
      if (this.downloading) {
        return
      }
      this.downloading = true;

      let response = await axios.post(this.url, {}, {
        responseType: "arraybuffer",
      });


      let fileNameFromURL = null
      let explodedUrl = ('' + this.url).replace('https://', '').replace('http://', '').split('/')
      if (explodedUrl && explodedUrl.length > 1) {
        let lastSegment = explodedUrl[explodedUrl.length - 1]
        if (lastSegment.includes('.')) {
          fileNameFromURL = lastSegment
        }

      }

      let filename = this.filename ? this.filename : fileNameFromURL ? fileNameFromURL : 'no-name.txt'

      this.downloading = false;
      const link = document.createElement("a");
      const blob = new Blob([response.data]);
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    }
  }

}

</script>
